import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import GlobalStyles from "../../_global.scss";
import "./table.scss";
import Pagination from "../Pagination";

const SimpleTable = ({
  data,
  columns,
  indication,
  totalRecords,
  totalPages,
  pageSize,
  currentPage,
  setCurrentPage,
  setPageSize,
  refetch,
  showPagination = true,
}) => {
  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (refetch) {
      refetch();
    }
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1); // Reset to first page when changing page size
    if (refetch) {
      refetch();
    }
  };

  return (
    <div>
      <BootstrapTable
        remote
        onTableChange={() => {}}
        bootstrap4
        keyField="id" // id / slug
        data={data}
        columns={columns}
        bordered={false}
        noDataIndication={indication}
        pagination={false} // Disable built-in pagination
      />
    </div>
  );
};

export default SimpleTable;
